import { conditionTitle } from './catalog';

/**
 * Состояние словом сразу за наименованием: «Фара Toyota Camry 2007 · б/у».
 *
 * <p>«Новая» и «контрактная» — разный товар и разная цена, а различала их до сих
 * пор только пометка в хвосте наименования, которая из него уходит (0315, 0316).
 * Появилось у продавца в задаче 0314; общим стало в 0318, когда то же понадобилось
 * составу сделки, странице по ссылке, заказам, обходу и приёмке: копия
 * в каждом экране разошлась бы с остальными на первой правке.
 *
 * <p>Приглушённо и отдельным элементом: наименование остаётся наименованием.
 * Пустой или незнакомый код — ничего, без прочерка: код («USED») человеку
 * не показывается вовсе.
 */
export function ConditionWord({ code }: { code: string | null | undefined }) {
  const word = conditionTitle(code);
  return word === null ? null : <span className="muted"> · {word}</span>;
}
